import { createApp } from "vue";
import App from "./App.vue";
import router from "./router.js";
import store, { pinia } from "./store/index.js";
import "v-calendar/dist/style.css";
import "../styles.css";

import Checkbox from "./components/ui/Checkbox.vue";
import ButtonInner from "./components/ui/ButtonInner.vue";
import DisplayModal from "./components/ui/DisplayModal.vue";
import scrollIntoView from "smooth-scroll-into-view-if-needed";

const app = createApp(App).use(pinia).use(router);

app.mixin({
  computed: {
    appStore() {
      return store;
    },
  },
});

app.config.globalProperties.win = window;
app.config.globalProperties.con = console;
app.config.globalProperties.doc = document;
app.config.globalProperties.$version = import.meta.env.VITE_APP_VERSION;

app.component("Checkbox", Checkbox);
app.component("ButtonInner", ButtonInner);
app.component("DisplayModal", DisplayModal);

app.mount("#app");

window.scrollIntoView = scrollIntoView;
